import { onMounted, ref } from 'vue'

export default {
    name: 'ArticleAnchors',
    setup() {
        const headerList = ref([])
        onMounted(() => {
            document.querySelectorAll('.kb-rich-text').forEach((richText) =>
                richText.querySelectorAll('h2').forEach((header) => {
                    // in case this particular instance is running in an overlay,
                    // we do not want to expand the exisiting link-list on the main article with links to
                    // headers inside an overlay.
                    if (header.getAttribute('id')) return

                    const id = header.textContent.replaceAll(' ', '_')
                    const span = document.createElement('span')
                    span.classList.add('anchor-target')
                    span.setAttribute('id', id)
                    header.appendChild(span)

                    headerList.value.push({
                        href: id,
                        displayName: header.textContent
                    })
                })
            )

            if (!location.hash) return

            document.querySelector(decodeURI(location.hash)).scrollTo()
        })

        return {
            headerList
        }
    }
}
